/** Primeira letra maiúscula, o resto intacto (`"obra"` → `"Obra"`, `"árvore"` → `"Árvore"`); vazio devolve vazio. */
export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
